import React, { Component } from "react";
import { Radio } from "antd";

class TwelveStatements extends Component {
  constructor() {
    super();
    this.state = {
      displayedQuestion: "",
      currentState: 1,
      firstChoice: 0,
      secondChoice: 0
    };
  }

  render() {
    let headlines;
    const choices = this.props.choices;
    switch (this.state.currentState) {
      case 1:
        headlines = {
          dk: "Vælg det udsagn du er mest enig i",
          en: "Choose the statement that you agree with the most"
        };

        choices.forEach(x => (x.blocked = false));
        choices.slice(0, 6).forEach(x => (x.blocked = true));

        break;
      case 2:
        headlines = {
          dk: "Vælg det udsagn du er mindst enig i",
          en: "Choose the statement that you agree with the last"
        };

        choices.forEach(x => (x.blocked = false));
        choices.slice(4, 10).forEach(x => (x.blocked = true));

        break;
      case 3:
        headlines = {
          dk: "Vælg det udsagn der er midterst",
          en: "Choose the middle statement"
        };

        choices.forEach(x => (x.blocked = false));

        choices.slice(5, 10).forEach(x => (x.blocked = true));

        choices.slice(0, 4).forEach(x => (x.blocked = true));

        break;
      default:
        headlines = {
          dk: "Score nu de resterende udsagn som du ønsker.",
          en: "Now score the statements as you wish"
        };

        choices.forEach(x => (x.blocked = false));

        choices
          .slice(this.state.firstChoice - 1, 10)
          .forEach(x => (x.blocked = true));

        choices
          .slice(0, this.state.secondChoice)
          .forEach(x => (x.blocked = true));

        break;
    }

    const allCategoriQuestions = Object.keys(this.props.questions).map(question => {
        if (
          !!this.props.questionValues[question] &&
          this.props.questionValues[question].notAnswered
        ) {
          return (
            <div
              className="twelveStatementQuestion"
              onClick={() =>
                onClickMethod(question, this.props.questions[question])
              }
            >
              <h3
                style={{
                  padding: "20px",
                  color: "#1ABC9C",
                  fontSize: "20px",
                  textTransform: "uppercase"
                }}
              >
                {this.props.questions[question].title}
              </h3>
            </div>
          );
        }

        return null;
      }
    );

    const onChangeMethod = (key, value) => {
      if (this.state.currentState === 1) {
        this.setState({ firstChoice: value});
      }
      if (this.state.currentState === 2) {
        this.setState({ secondChoice: value});
      }
      this.props.onChange(key, value);
      this.setState({
        displayedQuestion: this.state.allCategoriQuestions,
        currentState: this.state.currentState + 1
      });

      if (this.state.currentState === 5) {
        this.props.changeCurrent();

        this.setState({ currentState: 1 });
      }
    };
    const renderChoices = choices.map(choice => (
      <div id="multiplechoiceClass">
        <form>{choice.title}</form>
        <Radio
          defaultChecked={false}
          disabled={choice.blocked}
          style={{
            padding: "7px "
          }}
          value={choice.value}
        >
          {choice.description}
        </Radio>
      </div>
    ));

    const onClickMethod = (key, question) => {
      this.setState({
        displayedQuestion: (
          <div>
            <h3
              style={{
                padding: "20px",
                color: "#1ABC9C",
                fontSize: "20px",
                textTransform: "uppercase"
              }}
            >
              {question.title}
            </h3>
            <Radio.Group
              style={{ display: "block" }}
              onChange={e => onChangeMethod(key, e.target.value)}
            >
              {renderChoices}
            </Radio.Group>
          </div>
        )
      });
    };

    return (
      <div
        style={{
          backgroundColor: "#fff",
          padding: "10px 0px 30px",
          borderRadius: "5px"
        }}
      >
        <h3>{headlines[this.props.language]}</h3>
        {this.state.displayedQuestion
          ? this.state.displayedQuestion
          : allCategoriQuestions}
      </div>
    );
  }
}
export default TwelveStatements;



// WEBPACK FOOTER //
// ./src/components/MultipleChoice/TwelveStatements/index.js